import { IAggregator } from 'src/types/aggregator.types';
import { IPriceRule } from 'src/types/price.types';
import { IPricingCategory } from 'src/api/getPricingCategories/types';
import { IPriceBandWithVenues } from 'src/types/priceBand.types';

export type TChannelAndRules = IAggregator & IPriceRule;
export type TChannelAction = [string | null, 'create' | 'delete' | 'edit' | null, number | undefined];

export type TDescriptiveRow = { _type: 'descriptive'; label: string };
export type TEmptyRow = { _type: 'empty'; message: string };
export type TCreateBandCtaRow = { _type: 'create-band-cta' };
export type TInlineCreateRow = { _type: 'inline-create' };
export type TTableRow =
  | TDescriptiveRow
  | TEmptyRow
  | TCreateBandCtaRow
  | TInlineCreateRow
  | (IPriceRule & {
      categoryRows?: TPricingCategoryRow[];
      venueCount?: number;
      venues?: IPriceBandWithVenues['venues'];
      externalSystemName?: string;
    })
  | TPricingCategoryRow;

export const isDescriptiveRow = (row: TTableRow): row is TDescriptiveRow =>
  '_type' in row && row._type === 'descriptive';
export const isEmptyRow = (row: TTableRow): row is TEmptyRow => '_type' in row && row._type === 'empty';
export const isCreateBandCtaRow = (row: TTableRow): row is TCreateBandCtaRow =>
  '_type' in row && row._type === 'create-band-cta';
export const isInlineCreateRow = (row: TTableRow): row is TInlineCreateRow =>
  '_type' in row && row._type === 'inline-create';

export type TPricingCategoryRow = {
  _type: 'pricing_category';
  category: IPricingCategory;
  parentId: string;
  parentType: 'price_band' | 'extension_instance';
  overrideRule?: IPriceRule;
  inheritedRule?: IPriceRule;
  children?: TPricingCategoryRow[];
};

export const isChannelRow = (row: TTableRow): row is IPriceRule =>
  !isDescriptiveRow(row) && 'extension_instance' in row && !!row.extension_instance;

export const isPricingCategoryRow = (row: TTableRow): row is TPricingCategoryRow =>
  '_type' in row && row._type === 'pricing_category';
